import { compact, date, eq } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { FILTER } from '../../../../types/filters';
import { MEDIA_TYPE } from '../../../../types/press-media';
import { PressRelease } from '../../../../types/press-release';
import { toLink, toText } from '../../fields';
import {
  regionTypeDefault,
  toRegionType,
  toThematicType,
} from '../../mapping/index';
import { image } from '../../partials/image';
import { documentEntity } from './internal/document';

const processPressRelease = (entity: any): PressRelease => {
  return compact({
    type: DocumentType.PRESS_RELEASE,
    title: toText(entity.data?.title),
    description: toText(entity.data?.description),
    thematic: toThematicType(entity.data?.thematic),
    localization:
      toRegionType(entity.data?.localization) || regionTypeDefault(),
    image: image(entity.data),
    related_article: toLink(entity.data?.related_article),
    publication_date: date(entity.data?.publication_date, 'YYYY-MM-DD'),
    release_date: date(entity.data?.release_date, 'YYYY-MM-DD'),
    link: toLink(entity.data?.uri),
    onFinance: eq('visible_finance', 'oui', false, entity?.data),
    onNewsroom: eq('visible_newsroom', 'oui', true, entity?.data),
    filters: compact({
      [FILTER.REGION]:
        toRegionType(entity.data?.localization) || regionTypeDefault(),
      [FILTER.THEMATIC]: toThematicType(entity.data?.thematic),
      [FILTER.MEDIA_TYPE]: MEDIA_TYPE.RELEASE,
    }),
  });
};

export const PressReleaseEntity = documentEntity<PressRelease>(
  DocumentType.PRESS_RELEASE,
  {
    processStrategy: processPressRelease,
  }
);
